/* eslint-disable max-len */
import FluxQuestion from 'images/coin-pages/questions/flux.svg'

import { ICoinPageData } from '../types'
import { blogCards, commonSlidesData } from '../commonPageData'

export const fluxPage: ICoinPageData = {
  title: 'coin_425',
  description: 'coin_426',
  // description:
  //   'Get a Flux loan. Receive up to 90% of your FLUX loan collateral in cash or crypto and continue holding. Borrow Flux instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Flux (FLUX)' }) }} />
  ),
  questionsBlock: {
    image: FluxQuestion,
    questions: [
      {
        title: 'coin_427',
        answer: 'coin_428',
      },
      {
        title: 'coin_429',
        answer: 'coin_430',
      },
      {
        title: 'coin_431',
        answer: 'coin_432',
      },
      {
        title: 'coin_433',
        answer: 'coin_434',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Flux (FLUX)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_435',
        text: ['coin_437', 'coin_438'],
      },
      {
        title: 'coin_436',
        text: ['coin_439'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-flux-crypto-and-how-to-gain-profit-with-it/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/05/flux2.png',
        imageAlt: 'What is Flux Crypto and How to Gain Profit With It?',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
